export enum WilsonApp {
  Portal = 'portal',
  Mobile = 'mobile',
}
